import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Button } from '@americanexpress/dls-react';
import { IconSuccess } from '@americanexpress/dls-icons';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import styles from './RegistrationSuccess.scss';

const RegistrationSuccess = ({ onContinue = undefined }) => {
  const intl = useIntl();

  const handleContinue = () => {
    if (onContinue) {
      onContinue();
    }
  };

  return (
    <div className={styles['registration-success']}>
      <div className={styles['registration-success__card']}>
        <Header />

        <div className={styles['registration-success__body']}>
          <div className={styles['registration-success__title-row']}>
            <div className={styles['registration-success__icon']}>
              <IconSuccess
                className={styles['registration-success__icon-symbol']}
                size="md"
                isFilled={true}
                color="brand"
                title={intl.formatMessage({ id: 'passkeyRegistration.success.title' })}
              />
            </div>

            <h1 className={styles['registration-success__title']}>
              {intl.formatMessage({ id: 'passkeyRegistration.success.title' })}
            </h1>
          </div>

          <p className={styles['registration-success__message']}>
            {intl.formatMessage({ id: 'passkeyRegistration.success.message' })}
          </p>

          <Button
            className={styles['registration-success__continue-btn']}
            onClick={handleContinue}
          >
            {intl.formatMessage({ id: 'passkeyRegistration.success.continueToMerchant' })}
          </Button>
        </div>

        <Footer />
      </div>
    </div>
  );
};

RegistrationSuccess.propTypes = {
  onContinue: PropTypes.func,
};

export default RegistrationSuccess;
